import {useCallback, useRef} from 'react';
import type {CodeList} from 'services/codelists/types';
import type {RootState} from 'store/types';
import {useCodelist} from 'services/codelists/hooks';
import {useAppSelector} from 'store/hooks';
import {getExpressionManifestationsBasedOnLocalCodelist} from '../functions/getExpressionManifestationsBasedOnLocalCodelist';

const useValueSelector = (
  expressionId: string,
  productFormOverride: CodeList,
  productForm: CodeList,
  productFormDetails: CodeList,
) => {
  const valueRef = useRef<CodeList | undefined>(undefined);
  return useCallback(
    (state: RootState): CodeList => {
      const value = getExpressionManifestationsBasedOnLocalCodelist(
        state,
        expressionId,
        {
          productFormOverride,
          productForm,
          productFormDetails,
        },
      );
      if (
        !valueRef.current ||
        JSON.stringify(valueRef.current) !== JSON.stringify(value)
      ) {
        valueRef.current = value;
      }

      return valueRef.current;
    },
    [expressionId, productForm, productFormDetails, productFormOverride],
  );
};

/**
 * Hook to generate expression_manifestation_based_on codelist for given expression id
 */
export const useExpressionManifestationsBasedOnLocalCodelist = (
  expressionId: string,
): CodeList => {
  const productFormOverrideCodelist = useCodelist('product_form_simple_values');
  const productFormCodelist = useCodelist('PRODUCT_FORM');
  const productFormDetailCodelist = useCodelist('PRODUCT_FORM_DETAIL');
  const selector = useValueSelector(
    expressionId,
    productFormOverrideCodelist,
    productFormCodelist,
    productFormDetailCodelist,
  );
  const value = useAppSelector(selector);

  return value;
};
